export interface RnQpMessage {
  _id: string;
  author?: { _id: string; firstName?: string; lastName?: string; userName?: string; email?: string } | string | null;
  authorName?: string;
  kind: 'request' | 'response';
  text: string;
  createdAt: string;
}

export interface RnQpDecision {
  decision: 'approved' | 'rejected' | null;
  decidedBy?: { _id: string; firstName?: string; lastName?: string; userName?: string } | string;
  decidedAt: string;
  reason?: string;
  checklist: { key: string; checked: boolean }[];
  rnUpdatedAt?: string;
  rnNumber?: string;
}

export interface RnQpReleaseTransfer {
  document: string;
  number: string;
  createdAt: string;
}

export interface RnQpThread {
  _id: string;
  number: string;
  rnWorkOrder: string;
  subject: string;
  dateTo?: string | null;
  status: 'open' | 'answered' | 'closed';
  recipients: { userId: any; username?: string }[];
  messages: RnQpMessage[];
  decision?: RnQpDecision | null;
  /** System transfer ГП карантин → магацин ГП, created together with an approved decision. */
  releaseTransfer?: RnQpReleaseTransfer | null;
  createdAt: string;
  updatedAt: string;
}

export const normalizeRnQp = (value: any): RnQpThread | null => {
  const row = value?.data || value;
  return row && typeof row._id === 'string' ? row as RnQpThread : null;
};

export const normalizeRnQpList = (value: any): RnQpThread[] => Array.isArray(value) ? value : Array.isArray(value?.data) ? value.data : [];

export const rnQpUserLabel = (user: any): string => {
  if (!user || typeof user === 'string') return '';
  return [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || user.userName || user.email || '';
};
